import React from "react";

import { BooleanInput, ReferenceInput, AutocompleteInput } from "react-admin";
import SearchInput from "../common/SearchInput";
import DomainManagerSelectInput from "./DomainManagerSelectInput";

const domainFilters = [
  <SearchInput
    label="common.search"
    source="q"
    alwaysOn
    resettable
    autoFocus
  />,
  <ReferenceInput
    source="customerId"
    reference="Customer"
    sort={{ field: "name", order: "ASC" }}
    filterToQuery={(searchText: any) => ({
      q: searchText,
    })}
    alwaysOn
  >
    <AutocompleteInput optionText="name" emptyText="- alle -" />
  </ReferenceInput>,
  <BooleanInput source="isMainDomain" />,
  <ReferenceInput
    source="mainDomainId"
    reference="Domain"
    sort={{ field: "unicodeName", order: "ASC" }}
    filterToQuery={(searchText: any) => ({
      isMainDomain: true,
      q: searchText,
    })}
  >
    <AutocompleteInput optionText="unicodeName" />
  </ReferenceInput>,
  <DomainManagerSelectInput source="managedBy" />,
  <BooleanInput source="mailEnabled" />,
  <BooleanInput source="withoutServiceBooking" />,
];

export default domainFilters;
